import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
//
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import { AdapterMomentJalaali } from '@mui/x-date-pickers/AdapterMomentJalaali';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextFieldDate.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFTextFieldDate({ name, label, helperText, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
          <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
            <DatePicker
              label={label}
              value={field.value}
              onChange={(newValue) => {
                field.onChange(newValue);
              }}
              // renderInput={(params) => (
              //   <TextField {...params} fullWidth error={!!error} helperText={error?.message} />
              // )}
              slotProps={{ textField: {} }}
            />
          </LocalizationProvider>
      )}
    />
  );
}
